import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { MechanicService } from './mechanics.service';

@NgModule({
  providers: [
    MechanicService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class MechanicsModule {}
